import { gql } from '@apollo/client'

export const CREATE_AI_DESCRIPTION_JOB = gql`
  mutation createAiDescriptionJob($file: Upload!) {
    createAiDescriptionJob(input: { file: $file }) {
      fileAiDescriptionId
      success
      errors
    }
  }
`
